<template>
	<div
		class="data-table__row"
		:class="{
			'data-table__row--selectable': isSelectable,
			'data-table__row--total': isTotal,
			'data-table__row--super-total': isSuperTotal
		}"
	>
		<slot />
	</div>
</template>
<script lang="ts">
export default {
	name: 'DataTableRow'
};
</script>
<script setup lang="ts">
interface Props {
	isSelectable?: boolean;
	isTotal?: boolean;
	isSuperTotal?: boolean;
}
withDefaults(defineProps<Props>(), {
	isSelectable: false,
	isTotal: false,
	isSuperTotal: false
});
</script>
